//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyBasePage from "../../components/MyBasePage";
export default {
  name: "About",
  components: {
    MyBasePage,
  },
  data() {
    return {};
  },
  methods: {
    handleService() {
      // window.open("/chatlink.html", "_blank");
      window.location.href = "/chatlink.html";
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/About/index.vue